'use strict';

exports.__esModule = true;

var _redux = require('redux');

var _insurances = require('./insurances');

var _insurances2 = _interopRequireDefault(_insurances);

var _relativeTypes = require('./relativeTypes');

var _relativeTypes2 = _interopRequireDefault(_relativeTypes);

var _clinics = require('./clinics');

var _clinics2 = _interopRequireDefault(_clinics);

var _appointments = require('./appointments');

var _appointments2 = _interopRequireDefault(_appointments);

var _confirmations = require('./confirmations');

var _confirmations2 = _interopRequireDefault(_confirmations);

var _workingHours = require('./workingHours');

var _workingHours2 = _interopRequireDefault(_workingHours);

var _roles = require('./roles');

var _roles2 = _interopRequireDefault(_roles);

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

var _vacations = require('./vacations');

var _vacations2 = _interopRequireDefault(_vacations);

var _patients = require('./patients');

var _patients2 = _interopRequireDefault(_patients);

var _room = require('./room');

var _room2 = _interopRequireDefault(_room);

var _country = require('./country');

var _country2 = _interopRequireDefault(_country);

var _schedules = require('./schedules');

var _schedules2 = _interopRequireDefault(_schedules);

var _payment = require('./payment');

var _payment2 = _interopRequireDefault(_payment);

var _specialties = require('./specialties');

var _specialties2 = _interopRequireDefault(_specialties);

var _prefixTitles = require('./prefixTitles');

var _prefixTitles2 = _interopRequireDefault(_prefixTitles);

var _professionalTitles = require('./professionalTitles');

var _professionalTitles2 = _interopRequireDefault(_professionalTitles);

var _entities = require('./entities');

var _entities2 = _interopRequireDefault(_entities);

var _services = require('./services');

var _services2 = _interopRequireDefault(_services);

var _aman = require('./aman');

var _aman2 = _interopRequireDefault(_aman);

var _assistant = require('./assistant');

var _assistant2 = _interopRequireDefault(_assistant);

var _citiesAndAreas = require('./citiesAndAreas');

var _citiesAndAreas2 = _interopRequireDefault(_citiesAndAreas);

var _accounts = require('./accounts');

var _accounts2 = _interopRequireDefault(_accounts);

var _Pharma = require('./Pharma');

var _Pharma2 = _interopRequireDefault(_Pharma);

var _widgets = require('./widgets');

var _widgets2 = _interopRequireDefault(_widgets);

var _bid = require('./bid');

var _bid2 = _interopRequireDefault(_bid);

var _filters = require('./filters');

var _filters2 = _interopRequireDefault(_filters);

var _activities = require('./activities');

var _activities2 = _interopRequireDefault(_activities);

var _invoices = require('./invoices');

var _invoices2 = _interopRequireDefault(_invoices);

var _servicesAndOperations = require('./servicesAndOperations');

var _servicesAndOperations2 = _interopRequireDefault(_servicesAndOperations);

var _doctor = require('./doctor');

var _doctor2 = _interopRequireDefault(_doctor);

var _plans = require('./plans');

var _plans2 = _interopRequireDefault(_plans);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  plans: _plans2.default,
  doctor: _doctor2.default,
  servicesAndOperations: _servicesAndOperations2.default,
  invoices: _invoices2.default,
  activities: _activities2.default,
  filters: _filters2.default,
  bids: _bid2.default,
  insurances: _insurances2.default,
  relativeTypes: _relativeTypes2.default,
  workingHours: _workingHours2.default,
  clinics: _clinics2.default,
  room: _room2.default,
  appointments: _appointments2.default,
  confirmations: _confirmations2.default,
  roles: _roles2.default,
  user: _user2.default,
  vacations: _vacations2.default,
  patients: _patients2.default,
  country: _country2.default,
  schedules: _schedules2.default,
  payment: _payment2.default,
  specialties: _specialties2.default,
  prefixTitles: _prefixTitles2.default,
  professionalTitles: _professionalTitles2.default,
  entities: _entities2.default,
  services: _services2.default,
  aman: _aman2.default,
  assistant: _assistant2.default,
  citiesAndAreas: _citiesAndAreas2.default,
  accounts: _accounts2.default,
  pharma: _Pharma2.default,
  widgets: _widgets2.default
});
module.exports = exports['default'];